import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { makeId } from "../utils/id";

export const saveTableDataToFirestore = async (tableData, viewId) => {
  const jsonContent = JSON.stringify({
    dataSource: { type: "json", data: tableData },
    options: {
            viewType: "charts", 
            chart: {
                type: "bar" 
            }
        }
  });

  const newId = makeId(10);

  const newContent = {
    id: newId,
    content: jsonContent,
    cards: 3,
    type: "data-visualization",
  };

  const docRef = doc(db, "views", viewId);
  try {
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      let contentArray = docSnap.data().contents || [];
      if (!contentArray.some((comp) => comp.id === newId)) {
        contentArray.push(newContent);
        await updateDoc(docRef, {
          contents: contentArray,
        });
        console.log("Data successfully saved to Firestore.");
        return newId;
      } else {
        console.error(`Component with id ${newId} already exists.`);
      }
    } else {
      console.log("Document does not exist!");
    }
  } catch (error) {
    console.error("Error saving data to Firestore:", error);
  }
};
